import ApiService from '../services/apiService';

const indexSafetyOrganizationsRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/safety_organizations', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const exportSafetyOrganizationRequest = ({
  dispatch,
  format = '.xlsx',
  responseType = 'text',
  params = {},
  callback,
  successCallback
}) =>
  ApiService.request('get', `/safety_organizations/export${format}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });

export default indexSafetyOrganizationsRequest;
